import {
	Component,
	EventEmitter,
	HostListener,
	Input,
	OnChanges,
	Output,
	SimpleChanges,
	ViewChild
} from '@angular/core';
import { MatOption } from '@angular/material/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatSelect } from '@angular/material/select';
import { SelectItem } from 'src/models/general/select.item.model';

@Component({
    selector: 'pim-ordered-multiselect',
    templateUrl: './ordered-multiselect.component.html',
    styleUrls: ['./ordered-multiselect.component.sass'],
    standalone: false
})
export class OrderedMultiselectComponent implements OnChanges {
	@Input()
	stylingContextTable: boolean = false;

	@Input()
	id!: string;

	// TODO: Form-Array ermöglichen? Im Dyn-Config Kontext reicht ne fg - bei product-marketplaces bspw. wär aber FG-Array nicer
	@Input() // Expected to have a "value"-formControl
	formGroupControl!: UntypedFormGroup;

	@Input()
	values!: SelectItem[] | null | undefined;
	@Input()
	label!: string;

	@Input()
	placeholder: string = '-';

	@Input()
	disabled: boolean = false;

	@Output()
	dataChange: EventEmitter<any> = new EventEmitter<any>();

	@ViewChild(MatSelect)
	multiSelect!: MatSelect;

	// Just for display
	selectedValues: any[] = [];

	// Ordered Selection - we need to keep the order,
	orderedSelectedValues: any[] = [];

	selectSorter: (a: MatOption, b: MatOption, options: MatOption[]) => number = (a: MatOption, b: MatOption) => {
		const aIndex = this.orderedSelectedValues.indexOf(a.value);
		const bIndex = this.orderedSelectedValues.indexOf(b.value);
		return aIndex > bIndex ? 1 : 0;
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.formGroupControl && changes.formGroupControl.firstChange) {
			const presetValue = this.formGroupControl.get('value')?.value;
			const splitValues = presetValue ? presetValue.split(';') : [];
			this.orderedSelectedValues = splitValues;
			this.selectedValues = splitValues;
			if (this.formGroupControl.disabled) {
				this.disabled = true;
			}
		}
	}

	onItemSelect(value: SelectItem): void {
		const valIndex = this.orderedSelectedValues.indexOf(value.id);

		if (valIndex === -1) {
			this.orderedSelectedValues.push(value.id);
		} else {
			this.orderedSelectedValues.splice(valIndex, 1);
		}

		this.selectedValues = this.orderedSelectedValues;
		this.formGroupControl.patchValue({value: this.orderedSelectedValues.join(';')});
		this.dataChange.emit(this.orderedSelectedValues.join(';'));
	}

	// HostListener(focus) does not work ... :shrug:
	open(): void {
		this.multiSelect.open();
	}

	@HostListener('blur')
	close(): void {
		if (!this.multiSelect.panelOpen) {
			this.multiSelect.open();
		}
	}

}
